// extracted by mini-css-extract-plugin
module.exports = {"registerCards":"RegisterCards_registerCards__1_hFS","cardsContainer":"RegisterCards_cardsContainer__7j7N8","card":"RegisterCards_card__bUORJ"};